import { render, staticRenderFns } from "./AnimationEditor.vue?vue&type=template&id=77960e1e&scoped=true"
import script from "./AnimationEditor.vue?vue&type=script&lang=js"
export * from "./AnimationEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77960e1e",
  null
  
)

export default component.exports